import React, { Component } from 'react';
import { Table, Tabs, Popconfirm, message } from 'antd';
import UpdateCompareRecord from './UpdateCompareRecord';
import UpdateCustomRecord from './UpdateCustomRecord';
import UpdateHonorRecord from './UpdateHonorRecord';
import ExportUtil from '../../../common/ExportUtil';
import UpdateWorkError from './UpdateWorkError';
import UpdateScore from './UpdateScore';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import PreviewModal from '../PreviewModal';
import UserSider from '../UserSider';
import Filter from './Filter';
import '../css/style.less';

const { TabPane } = Tabs;

class PmInfo extends Component {
    state = {
        data: [],
        sortParams: {},
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        config: {},
        loading: false,
        expandedRowKeys: [],
        canSynchronize: false,
        activeKey: 'overView',
        panes: [{
            title: 'PM信息总览',
            key: 'overView',
            content: null,
        }, {
            title: '竞标记录',
            key: 'compareRecord',
            content: null,
        }, {
            title: '大客户经理',
            key: 'mainCustomManager',
            content: null,
        }, {
            title: '公司层面或项目层面的奖杯、奖状、荣誉证书',
            key: 'honor',
            content: null,
        }, {
            title: '团队贡献度',
            key: 'teamContribute',
            content: null,
        }, {
            title: '工作失误',
            key: 'workError',
            content: null,
        }],
        subList: {},
    }

    componentDidMount() {
        this.loadData();
    }
    
    handleTabsChange = (activeKey) => {
        const pagination = {
            pageSize: 10,
            current: 1,
        };
        if (activeKey != 'overView' && activeKey != 'teamContribute') {
            pagination.pageSize = 3;
        }
        this.setState({
            activeKey,
            pagination,
            subList: {},
            sortParams: {},
            searchParams: {},
            expandedRowKeys: [],
        }, () => {
            activeKey != 'teamContribute' ? this.loadData() : this.updatePanes();
        });
    }

    updatePanes = () => {
        const { panes, activeKey } = this.state;
        panes.forEach(item => {
            if (item.key == activeKey) {
                item.content = this.getContent();
            } else {
                item.content = null;
            }
        });
        this.setState({ panes });
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: params,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { activeKey, sortParams, searchParams, pagination } = this.state;
        const params = {
            ...sortParams,
            ...searchParams,
        }
        if (activeKey == 'overView') {
            params.exportType = 'PM';
        } else if (activeKey == 'compareRecord') {
            params.exportType = 'BIDDING';
        } else if (activeKey == 'mainCustomManager') {
            params.exportType = 'PM_CUSTOMER_RECORD';
        } else if (activeKey == 'honor') {
            params.exportType = 'PM_AWARD';
        } else if (activeKey == 'teamContribute') {
            params.exportType = 'PM_SCORE_GRADE';
        } else if (activeKey == 'workError') {
            params.exportType = 'PM_WORK_MISTAKE';
        }
        ExportUtil.export(params, pagination, API_URL.user.exportPmList);
    }

    // 同步人员
    synchronizeUser = () => {
        this.setState({ loading: true });
        const options = {
            url: API_URL.user.createPmMemberUser,
            data: {},
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { activeKey, sortParams, searchParams, pagination, pagination: { current, pageSize } } = this.state;
        this.setState({ loading: true });

        let url = '';
        if (activeKey == 'overView' || activeKey == 'honor' || activeKey == 'workError') {
            url = API_URL.user.queryPmList;
        } else if (activeKey == 'compareRecord') {
            url = API_URL.user.queryPmBiddingFirstLevel;
        } else if (activeKey == 'mainCustomManager') {
            url = API_URL.user.queryPmCustomerRecordFirstLevel;
        } else if (activeKey == 'teamContribute') {
            url = API_URL.user.queryPmScoreGradeList;
        }
        const options = {
            method: 'POST',
            url,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { data = {}, datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;
                const { canSynchronize } = data;

                const expandedRowKeys = [];
                const values = Object.values(searchParams);
                if (values.some(i => !!i) && activeKey != 'overView' && activeKey != 'teamContribute') {
                    datas.forEach(i => expandedRowKeys.push(i.userId));
                }
                this.setState({
                    pagination,
                    data: datas,
                    config: data,
                    loading: false,
                    expandedRowKeys,
                    canSynchronize: canSynchronize == 'true',
                }, () => {
                    this.updatePanes();
                    expandedRowKeys.forEach(i => this.loadSubData(i));
                });
            }
        };
        $.sendRequest(options);
    }

    loadSubData = (userId) => {
        const { activeKey, searchParams } = this.state;
        this.setState({ loading: true });
        let url = '';
        if (activeKey == 'compareRecord') {
            url = API_URL.user.queryBiddingRecordList;
        } else if (activeKey == 'mainCustomManager') {
            url = API_URL.user.queryPmCustomerRecordList;
        } else if (activeKey == 'honor') {
            url = API_URL.user.queryPmAwardListByUserId;
        } else if (activeKey == 'workError') {
            url = API_URL.user.queryPmWorkMistakeByUserId;
        }
        const options = {
            method: 'POST',
            url,
            data: {
                ...searchParams,
                userId,
            },
            dataType: 'json',
            doneResult: res => {
                const { subList } = this.state;
                subList[userId] = res.list;
                this.setState({
                    subList,
                    loading: false,
                }, () => {
                    this.updatePanes();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    subDelete = (row) => {
        const { activeKey } = this.state;
        const { userId } = row;

        let url;
        const params = {};
        if (activeKey == 'compareRecord') {
            url = API_URL.user.delPmBiddingRecord;
            params.pmBiddingRecordId = row.pmBiddingRecordId;
        } else if (activeKey == 'mainCustomManager') {
            url = API_URL.user.delPmCustomerRecord;
            params.pmCustomerRecordId = row.pmCustomerRecordId;
        } else if (activeKey == 'honor') {
            url = API_URL.user.delPmAward;
            params.pmAwardId = row.pmAwardId;
        } else if (activeKey == 'workError') {
            url = API_URL.user.delPmWorkMistake;
            params.pmWorkMistakeId = row.pmWorkMistakeId;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: { ...params },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadSubData(userId);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            subList: {},
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const { activeKey, config } = this.state;
        const columns = []
        if (activeKey != 'teamContribute') {
            columns.push({
                title: '工号',
                dataIndex: 'employeeCode',
                key: 'employeeCode',
                width: 80,
                sorter: true,
                render: (text, record) => {
                    const { userId } = record;
                    if (activeKey == 'overView') {
                        return <a onClick={() => this.showPreviewModal(userId)}>{text}</a>;
                    } else {
                        return text;
                    }
                }
            }, {
                title: '姓名',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                width: 80,
            }, {
                title: '职位/级别',
                dataIndex: 'positionName',
                key: 'positionName',
                width: 100,
            });
            if (activeKey == 'overView') {
                columns.push({
                    title: '主管领导',
                    dataIndex: 'leaderName',
                    key: 'leaderName',
                    width: 150,
                }, {
                    title: '部门',
                    dataIndex: 'enterpriseDepartmentName',
                    key: 'enterpriseDepartmentName',
                    width: 150,
            });
            }
            columns.push({
                title: '手机号码',
                dataIndex: 'userMobile',
                key: 'userMobile',
                width: 150,
            },{
                title: '邮箱',
                dataIndex: 'email',
                key: 'email',
                width: 200,
            }, {
                title: '工作城市',
                dataIndex: 'workCity',
                key: 'workCity',
                width: 120,
            });
            if (activeKey == 'overView') {
                columns.push({
                    title: '状态',
                    dataIndex: 'workStatus',
                    key: 'workStatus',
                    width: 120,
            });
            } else if (activeKey == 'workError') {
                columns.push({
                    title: '主管领导工号',
                    dataIndex: 'leaderCode',
                    key: 'leaderCode',
                    width: 120,
                },{
                    title: '主管领导姓名',
                    dataIndex: 'leaderName',
                    key: 'leaderName',
                    width: 120,
                });
            }
            if (activeKey != 'overView') {
                columns.push({
                    title: '操作',
                    dataIndex: 'operate',
                    key: 'operate',
                    width: 120,
                    render: (text, record) => {
                        if (activeKey == 'compareRecord') {
                            return <a onClick={() => this.updateCompareRecord(record)}>添加竞标记录</a>
                        } else if (activeKey == 'mainCustomManager') {
                            return <a onClick={() => this.updateCustomRecord(record)}>添加客户记录</a>
                        } else if (activeKey == 'honor') {
                            return <a onClick={() => this.updateHonorRecord(record)}>添加荣誉记录</a>
                        } else if (activeKey == 'workError') {
                            return <a onClick={() => this.updateWorkError(record)}>添加工作失误</a>
                        }
                    }
                })
            }
        } else {
            const { canEdit } = config;
            columns.push({
                title: '考核时间',
                dataIndex: 'inspectionTimeShow',
                key: 'inspectionTimeShow',
                width: 85,
            }, {
                title: '工号',
                dataIndex: 'employeeCode',
                key: 'employeeCode',
                width: 80,
                sorter: true,
            }, {
                title: '姓名',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                width: 80,
            }, {
                title: '鼓励团队成员',
                dataIndex: 'encourageTeamMembers',
                key: 'encourageTeamMembers',
            }, {
                title: '正能量宣传',
                dataIndex: 'positiveEnergyPromotion',
                key: 'positiveEnergyPromotion',
            }, {
                title: '团队凝聚力',
                dataIndex: 'teamUnity',
                key: 'teamUnity',
            }, {
                title: '合计',
                dataIndex: 'total',
                key: 'total',
            }, {
                title: '主管总结性评语',
                dataIndex: 'comments',
                key: 'comments',
            }, {
                title: '评价人',
                dataIndex: 'appraiseUser',
                key: 'appraiseUser',
            }, {
                title: '评价时间',
                dataIndex: 'appraiseTime',
                key: 'appraiseTime',
                width: 85,
            });
            if (canEdit == 'true') {
                columns.push({
                    title: '操作',
                    dataIndex: 'operate',
                    key: 'operate',
                    width: 60,
                    render: (text, record) => {
                        return <a onClick={() => this.updateScore(record)}>加分</a>
                    }
                })
            }
        }
        return columns;
    }

    getDataSource = () => {
        const { data, pagination: { current, pageSize } } = this.state;
        const dataSource = data.map((item, index) => {
            const { workStatus, appraiseUserName, appraiseUserCode } = item;
            const appraiseUser =
                appraiseUserName ?
                    <span>
                        {appraiseUserName}
                        <br />
                        {appraiseUserCode ? `(${appraiseUserCode})` : ''}
                    </span>
                : '';
            return {
                key: index + 1,
                index: (current - 1) * pageSize + index + 1,
                ...item,
                appraiseUser,
                workStatus: workStatus ? (workStatus === 'WORKING' ? '在职' : "离职") : '',
            };
        });
        return dataSource;
    }

    onExpand = (expanded, record) => {
        const { expandedRowKeys } = this.state;
        if (expandedRowKeys.length == 0) {
            expandedRowKeys.push(record.userId);
        } else {
            if (expanded) {
                expandedRowKeys.push(record.userId);
            } else {
                expandedRowKeys.map((item, index) => {
                    if (item == record.userId) {
                        expandedRowKeys.splice(index, 1);
                    };
                });
            }
        }
        this.setState({ expandedRowKeys }, () => {
            this.updatePanes();
        });
        if (expanded) {
            this.loadSubData(record.userId);
        }
    }

    expandedRowRender = (record) => {
        const { userId } = record;
        const { subList, activeKey } = this.state;
        const subData = subList[userId] || [];
        const getColumns = () => {
            const columns = [];
            if (activeKey == 'compareRecord') {
                columns.push({
                    title: '序号',
                    dataIndex: 'index',
                    key: 'index',
                    width: 60,
                }, {
                    title: '竞标时间',
                    dataIndex: 'biddingTime',
                    key: 'biddingTime',
                    width: 100,
                    render: text => text ? text.slice(0, 10) : '',
                }, {
                    title: '客户名称',
                    dataIndex: 'customerCompanyName',
                    key: 'customerCompanyName',
                    width: 155,
                }, {
                    title: '项目领域',
                    dataIndex: 'investigationAreaName',
                    key: 'investigationAreaName',
                    width: 100,
                }, {
                    title: '疾病',
                    dataIndex: 'diseaseName',
                    key: 'diseaseName',
                    width: 120,
                    render: (text, record) => {
                        const { diseaseOther } = record;
                        return diseaseOther ? `${text}(${diseaseOther})` : text;
                    }
                }, {
                    title: '方案编号',
                    dataIndex: 'planNum',
                    key: 'planNum',
                    width: 120,
                }, {
                    title: '是否竞标获单',
                    dataIndex: 'isGetDeal',
                    key: 'isGetDeal',
                    width: 100,
                    render: text => (text || text === 0)  ? text ? '是' : '否' : '', 
                }, {
                    title: '操作',
                    dataIndex: 'operate',
                    key: 'operate',
                    width: 120,
                    render: (text, row) => {
                        return (
                            <span>
                                <a onClick={() => this.updateCompareRecord(record, row)}>修改</a>
                                <span className="ant-divider" />
                                <Popconfirm title="确定要删除吗?" onConfirm={() => this.subDelete(row)}>
                                    <a>删除</a>
                                </Popconfirm>
                            </span>
                        )
                    }
                });
            } else if (activeKey == 'mainCustomManager') {
                columns.push({
                    title: '序号',
                    dataIndex: 'index',
                    key: 'index',
                    width: 60,
                }, {
                    title: '客户类型',
                    dataIndex: 'customerTypeName',
                    key: 'customerTypeName',
                    width: 100,
                }, {
                    title: '客户名称',
                    dataIndex: 'customerCompanyName',
                    key: 'customerCompanyName',
                    width: 200,
                }, {
                    title: '主要对接人',
                    dataIndex: 'mainContactUserName',
                    key: 'mainContactUserName',
                    width: 100,
                }, {
                    title: '联系电话',
                    dataIndex: 'mainContactUserMobile',
                    key: 'mainContactUserMobile',
                    width: 135,
                }, {
                    title: '邮箱',
                    dataIndex: 'mainContactUserMail',
                    key: 'mainContactUserMail',
                    width: 160,
                }, {
                    title: '操作',
                    dataIndex: 'operate',
                    key: 'operate',
                    width: 120,
                    render: (text, row) => {
                        return (
                            <span>
                                <a onClick={() => this.updateCustomRecord(record, row)}>修改</a>
                                <span className="ant-divider" />
                                <Popconfirm title="确定要删除吗?" onConfirm={() => this.subDelete(row)}>
                                    <a>删除</a>
                                </Popconfirm>
                            </span>
                        )
                    }
                });
            } else if (activeKey == 'honor') {
                columns.push({
                    title: '序号',
                    dataIndex: 'index',
                    key: 'index',
                    width: 60,
                }, {
                    title: '获得荣誉时间',
                    dataIndex: 'awardTime',
                    key: 'awardTime',
                    width: 100,
                    render: text => text ? text.slice(0, 10) : '',
                }, {
                    title: '获得荣誉层面',
                    dataIndex: 'awardLevelShow',
                    key: 'awardLevelShow',
                    width: 160,
                }, {
                    title: '获得荣誉说明',
                    dataIndex: 'awardComments',
                    key: 'awardComments',
                    width: 300,
                }, {
                    title: '获得荣誉类型',
                    dataIndex: 'awardTypeShow',
                    key: 'awardTypeShow',
                    width: 135,
                }, {
                    title: '操作',
                    dataIndex: 'operate',
                    key: 'operate',
                    width: 120,
                    render: (text, row) => {
                        return (
                            <span>
                                <a onClick={() => this.updateHonorRecord(record, row)}>修改</a>
                                <span className="ant-divider" />
                                <Popconfirm title="确定要删除吗?" onConfirm={() => this.subDelete(row)}>
                                    <a>删除</a>
                                </Popconfirm>
                            </span>
                        )
                    }
                });
            } else if (activeKey == 'workError') {
                columns.push({
                    title: '序号',
                    dataIndex: 'index',
                    key: 'index',
                    width: 60,
                }, {
                    title: '工作失误发生时间',
                    dataIndex: 'mistakeTime',
                    key: 'mistakeTime',
                    width: 160,
                    render: text => text ? text.slice(0, 10) : '',
                }, {
                    title: '工作失误类型',
                    dataIndex: 'mistakeTypeName',
                    key: 'mistakeTypeName',
                    width: 235,
                }, {
                    title: '工作失误具体描述',
                    dataIndex: 'mistakeDescription',
                    key: 'mistakeDescription',
                    width: 300,
                }, {
                    title: '操作',
                    dataIndex: 'operate',
                    key: 'operate',
                    width: 120,
                    render: (text, row) => {
                        return (
                            <span>
                                <a onClick={() => this.updateWorkError(record, row)}>修改</a>
                                <span className="ant-divider" />
                                <Popconfirm title="确定要删除吗?" onConfirm={() => this.subDelete(row)}>
                                    <a>删除</a>
                                </Popconfirm>
                            </span>
                        )
                    }
                });
            }
            return columns;
        }
    
        const getDataSource = () => {
            const dataSource = [];
    
            if (subData && subData.length > 0) {
                subData.map((item, index) => {
                    dataSource.push({
                        index: index + 1,
                        ...item,
                    });
                });
            }
            return dataSource;
        };

        return (
            <Table
                rowKey={record => record.index}
                columns={getColumns()}
                dataSource={getDataSource()}
                pagination={false}
                scroll={{ x: 875, y: 300 }}
            />
        );
    }

    getContent =  () => {
        const { loading, activeKey, pagination, canSynchronize, expandedRowKeys } = this.state;
        return (
            <div>
                <Filter
                    activeKey={activeKey}
                    search={this.search}
                    export={this.export}
                    canSynchronize={canSynchronize}
                    synchronizeUser={this.synchronizeUser}
                />
                {
                    (activeKey == 'overView' || activeKey == 'teamContribute') ?
                        <Table
                            loading={loading}
                            scroll={{ x: 955 }}
                            pagination={pagination}
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.userId}
                            onChange={this.handleTableChange}
                        />
                    :
                        <Table
                            loading={loading}
                            scroll={{ x: 955 }}
                            pagination={pagination}
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.userId}
                            onChange={this.handleTableChange}
                            onExpand={this.onExpand}
                            expandedRowKeys={expandedRowKeys}
                            expandedRowRender={this.expandedRowRender}
                        />
                }
            </div>
        )
    }

    showPreviewModal = userId => {
        this.previewModalRef.show(userId);
    }

    updateCompareRecord = (parentParams, params) => {
        this.updateCompareRecordRef.show(parentParams, params);
    }

    updateCustomRecord = (parentParams, params) => {
        this.updateCustomRecordRef.show(parentParams, params);
    }

    updateHonorRecord = (parentParams, params) => {
        this.updateHonorRecordRef.show(parentParams, params);
    }

    updateScore = (record) => {
        this.updateScoreRef.show(record);
    }

    updateWorkError = (parentParams, params) => {
        this.updateWorkErrorRef.show(parentParams, params);
    }

    render() {
        const { panes, config, activeKey } = this.state;
        return (
            <div className="content pmInfo">
                <UserSider selectKey='pmInfo' openKeys={['sub3']}/>
                <div className="main">
                    <div className="main-content">
                        <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                            {
                                panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{pane.content}</TabPane>)
                            }
                        </Tabs>
                        <PreviewModal ref={el => this.previewModalRef = el} />
                        <UpdateCompareRecord ref={el => this.updateCompareRecordRef = el} loadData={this.loadSubData} />
                        <UpdateCustomRecord ref={el => this.updateCustomRecordRef = el} loadData={this.loadSubData} />
                        <UpdateHonorRecord ref={el => this.updateHonorRecordRef = el} loadData={this.loadSubData} />
                        <UpdateScore ref={el => this.updateScoreRef = el} config={config} loadData={this.loadData} />
                        <UpdateWorkError ref={el => this.updateWorkErrorRef = el} loadData={this.loadSubData} />
                    </div>
                </div>
            </div>
        );
    }
}

export default PmInfo;


// WEBPACK FOOTER //
// ./src/components/user/pmInfo/index.js